"use strict"

import React from "react"
import { Form } from "react-bootstrap"

export default function UserInputField({
  intl,
  values,
  controlName,
  handleChange,
  handleBlur,
  touched,
  errors,
  type,
  show_complexity_help,
}) {
  return (
    <div className={"row one-rem-margin-bottom"}>
      <label className={"col-3"}>
        &nbsp;
        {intl.formatMessage({ id: `administration.user-management.${controlName}` })}:&nbsp;
      </label>
      <div className={"col-9"}>
        <Form.Control
          type={type}
          name={controlName}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values[controlName]}
          className={touched[controlName] && errors[controlName] ? "validation-error" : null}
        />
        {touched[controlName] && errors[controlName] ? (
          <div className="error-message">{errors[controlName]}</div>
        ) : null}
        {show_complexity_help && (
          <Form.Text className="text-muted">
            {intl.formatMessage({ id: "administration.user-management.complexity.help_text" })}
          </Form.Text>
        )}
      </div>
    </div>
  )
}
